/* eslint-disable array-callback-return */
import Dropzone from 'react-dropzone';
import { createRef, useState } from 'react';
import { connect } from 'react-redux';

import { createGallery } from '../../services/gallery';
import { showToast } from 'redux/auth/auth.action';
import { Button, Spinner } from 'react-bootstrap';

const MyDropZoneLogo = ({
  onChange,
  setToaster,
  objectType = '',
  children,
}) => {
  const dropzoneRef = createRef();

  const [isUpload, setIsUpload] = useState(false);

  async function handleUploadImage(files) {
    try {
      setIsUpload(true);
      if (files?.length) {
        const file = files[0];
        if (!file.preview) {
          return;
        }
        const formData = new FormData();
        formData.append(
          'fieldModifiers',
          JSON.stringify({ avatar: file.name, objectType: objectType })
        );

        let demo = await fetch(file.preview).then((r) => r.blob());

        formData.append('file', demo);

        const res = await createGallery(formData);

        if (res.status === 200) {
          const publicURL = new URL(res.data.publicURL);
          publicURL.searchParams.set('_id', res.data.logoId);
          onChange?.(publicURL.href);
        } else {
          throw new Error('');
        }
      }
    } catch (error) {
      setToaster({
        type: 'error',
        show: true,
        message: 'Upload failed',
      });
    } finally {
      setIsUpload(false);
    }
  }
  return (
    <>
      <Dropzone
        maxFiles={1}
        maxSize={1024 * 1024 * 2}
        onDropRejected={(data) => {
          if (data?.[0]) {
            setToaster({
              type: 'error',
              show: true,
              message: 'File is larger than 2MB',
            });
          }
        }}
        accept='image/png,image/jpg,image/jpeg'
        onDropAccepted={(data) => {
          // handleUploadImage(data);
          onChange?.(data[0]);
        }}
        onDrop={(acceptedFiles) => {
          // uploadFileTest(acceptedFiles[0]);
          return acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          );
        }}
        ref={dropzoneRef}
        multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()}>
              <input {...getInputProps()} />

              {children ? (
                children
              ) : (
                <Button
                  disabled={isUpload}
                  type='submit'
                  variant='primary'
                  // isLoadingSubmitImport
                  className='d-flex'>
                  {isUpload && (
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                  )}
                  <span className=''>Select From System</span>
                </Button>
              )}
            </div>
          </section>
        )}
      </Dropzone>
    </>
  );
};

const mapStateToProps = ({ activeTabReducer: { modalAction } }) => ({
  modalAction: modalAction,
});
const mapDispatchToProps = (dispatch) => ({
  setToaster: (data) => dispatch(showToast(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyDropZoneLogo);
